import type { MappingSuggestionRow } from './suggestion-types';

/** The rows ticked so far, across pages, by listing id. */
export type RowSelection = ReadonlyMap<string, MappingSuggestionRow>;

export const addRows = (
  selection: RowSelection,
  rows: MappingSuggestionRow[],
): RowSelection =>
  new Map([...selection, ...rows.map(row => [row.listingId, row] as const)]);

export const removeIds = (
  selection: RowSelection,
  ids: string[],
): RowSelection => {
  const gone = new Set(ids);

  return new Map([...selection].filter(([id]) => !gone.has(id)));
};

export const toggleRow = (
  selection: RowSelection,
  row: MappingSuggestionRow,
): RowSelection =>
  selection.has(row.listingId)
    ? removeIds(selection, [row.listingId])
    : addRows(selection, [row]);
